var map = {
	"./": 18305,
	"./App": 9555,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Interfaces/Interfaces": 17039,
	"./Interfaces/Interfaces.js": 17039,
	"./components/About/About": 27810,
	"./components/About/About.jsx": 27810,
	"./components/About/About.module.css": 44329,
	"./components/BlogNews/BlogNews": 15484,
	"./components/BlogNews/BlogNews.jsx": 15484,
	"./components/BlogNews/BlogNews.module.css": 67798,
	"./components/Business/Business": 46087,
	"./components/Business/Business.jsx": 46087,
	"./components/Business/Business.module.css": 79325,
	"./components/CareerHero/CareerHero": 14524,
	"./components/CareerHero/CareerHero.jsx": 14524,
	"./components/CareerHero/CareerHero.module.css": 82669,
	"./components/CareerProducts/CareerProducts": 27384,
	"./components/CareerProducts/CareerProducts.jsx": 27384,
	"./components/CareerProducts/CareerProducts.module.css": 12035,
	"./components/CareerProducts/CareerTable": 3607,
	"./components/CareerProducts/CareerTable.jsx": 3607,
	"./components/Contacts/Contacts": 51100,
	"./components/Contacts/Contacts.jsx": 51100,
	"./components/Contacts/Contacts.module.css": 71914,
	"./components/CoperateClients/CoperateClients": 90438,
	"./components/CoperateClients/CoperateClients.jsx": 90438,
	"./components/CoperateClients/CoperateClients.module.css": 12613,
	"./components/Dropdown/Dropdown.module.css": 69613,
	"./components/Dropdown/DropdownProducts": 79026,
	"./components/Dropdown/DropdownProducts.jsx": 79026,
	"./components/Dropdown/DropdownSubsidiaries": 6776,
	"./components/Dropdown/DropdownSubsidiaries.jsx": 6776,
	"./components/Email/Email": 51585,
	"./components/Email/Email.jsx": 51585,
	"./components/Email/Email.module.css": 19067,
	"./components/Footer/Footer": 73000,
	"./components/Footer/Footer.jsx": 73000,
	"./components/Footer/Footer.module.css": 42747,
	"./components/Hero/Hero": 13515,
	"./components/Hero/Hero.jsx": 13515,
	"./components/Hero/Hero.module.css": 52444,
	"./components/LeaderShip/LeaderShip": 83815,
	"./components/LeaderShip/LeaderShip.jsx": 83815,
	"./components/LeaderShip/LeaderShip.module.css": 31762,
	"./components/Management/Management": 89366,
	"./components/Management/Management.jsx": 89366,
	"./components/Management/Management.module.css": 12601,
	"./components/Modal/Modal": 55488,
	"./components/Modal/Modal.jsx": 55488,
	"./components/Modal/Modal.module.css": 98642,
	"./components/Navbar/Navbar": 92657,
	"./components/Navbar/Navbar.jsx": 92657,
	"./components/Navbar/Navbar.module.css": 98546,
	"./components/NotFound/NotFound": 67216,
	"./components/NotFound/NotFound.jsx": 67216,
	"./components/NotFound/NotFound.module.css": 83511,
	"./components/PagePagination/PagePagination": 93980,
	"./components/PagePagination/PagePagination.css": 75876,
	"./components/PagePagination/PagePagination.jsx": 93980,
	"./components/PagePagination/usePagination": 43333,
	"./components/PagePagination/usePagination.jsx": 43333,
	"./components/PartnerProducts/PartnerProducts": 11275,
	"./components/PartnerProducts/PartnerProducts.jsx": 11275,
	"./components/Quote/Quote": 96527,
	"./components/Quote/Quote.jsx": 96527,
	"./components/Quote/Quote.module.css": 36944,
	"./components/RecentUpdates/RecentUpdates": 3121,
	"./components/RecentUpdates/RecentUpdates.jsx": 3121,
	"./components/RecentUpdates/RecentUpdates.module.css": 63791,
	"./components/School/School": 85827,
	"./components/School/School.jsx": 85827,
	"./components/Search/Search": 51111,
	"./components/Search/Search.jsx": 51111,
	"./components/Search/Search.module.css": 75646,
	"./components/ShopFacts/ShopFacts": 82481,
	"./components/ShopFacts/ShopFacts.jsx": 82481,
	"./components/ShopFacts/ShopFacts.module.css": 78478,
	"./components/ShopHero/ShopHero": 12252,
	"./components/ShopHero/ShopHero.jsx": 12252,
	"./components/ShopHero/ShopHero.module.css": 74164,
	"./components/ShopQuestions/ShopQuestions": 65333,
	"./components/ShopQuestions/ShopQuestions.jsx": 65333,
	"./components/ShopQuestions/ShopQuestions.module.css": 36293,
	"./components/ShopScreen/ShopScreen": 74962,
	"./components/ShopScreen/ShopScreen.jsx": 74962,
	"./components/ShopScreen/ShopScreen.module.css": 32121,
	"./components/ShopTower/ShopTower": 93301,
	"./components/ShopTower/ShopTower.jsx": 93301,
	"./components/ShopTower/ShopTower.module.css": 83668,
	"./components/ShoppingCards/ShoppingCards": 77019,
	"./components/ShoppingCards/ShoppingCards.jsx": 77019,
	"./components/ShoppingCards/ShoppingCart.css": 13288,
	"./components/Subsidiaries/Subsidiaries": 68410,
	"./components/Subsidiaries/Subsidiaries.jsx": 68410,
	"./components/Subsidiaries/Subsidiaries.module.css": 61127,
	"./components/SubsidiariesProducts/SubsidiariesProducts": 35629,
	"./components/SubsidiariesProducts/SubsidiariesProducts.jsx": 35629,
	"./images/Carousel.png": 3335,
	"./images/Rectangle 17.png": 8123,
	"./images/about.jpeg": 61048,
	"./images/about.png": 12788,
	"./images/about1.png": 40801,
	"./images/about2.png": 93554,
	"./images/about3.png": 99944,
	"./images/about4.png": 86639,
	"./images/about5.png": 98371,
	"./images/about6.png": 36183,
	"./images/about7.png": 43007,
	"./images/blog.jpeg": 84392,
	"./images/blogBlog1.jpg": 75424,
	"./images/blogBlog10.jpg": 84835,
	"./images/blogBlog2.jpg": 53807,
	"./images/blogBlog3.jpg": 10698,
	"./images/blogBlog4.jpg": 52902,
	"./images/blogBlog5.jpg": 79430,
	"./images/blogBlog6.jpg": 71421,
	"./images/blogBlog7.jpg": 55968,
	"./images/blogBlog8.jpg": 37806,
	"./images/blogBlog9.jpg": 62594,
	"./images/blogNews1.jpg": 84421,
	"./images/blogNews10.jpg": 45954,
	"./images/blogNews2.jpg": 20528,
	"./images/blogNews3.jpg": 34066,
	"./images/blogNews4.jpg": 13127,
	"./images/blogNews5.jpg": 76293,
	"./images/blogNews6.jpg": 57495,
	"./images/blogNews7.jpg": 68330,
	"./images/blogNews8.jpg": 84058,
	"./images/blogNews9.jpg": 1181,
	"./images/business1.jpg": 53057,
	"./images/business2.jpg": 28031,
	"./images/business3.jpg": 6809,
	"./images/business4.jpg": 32998,
	"./images/cbc-tower.png": 5976,
	"./images/cbc.png": 83299,
	"./images/contact.jpeg": 99585,
	"./images/deputygeneralmanager.png": 24607,
	"./images/generalmanager.png": 8767,
	"./images/hero.png": 52141,
	"./images/hero1.jpg": 76995,
	"./images/hero2.jpg": 99759,
	"./images/hero3.jpg": 56793,
	"./images/hero4.jpg": 72947,
	"./images/image1.svg": 58385,
	"./images/image10.svg": 80141,
	"./images/image11.svg": 26525,
	"./images/image12.svg": 84416,
	"./images/image13.svg": 77343,
	"./images/image14.svg": 73230,
	"./images/image15.svg": 44766,
	"./images/image16.svg": 29439,
	"./images/image17.svg": 53437,
	"./images/image18.svg": 6591,
	"./images/image19.svg": 63716,
	"./images/image2.svg": 50654,
	"./images/image3.svg": 99970,
	"./images/image4.svg": 71337,
	"./images/image5.svg": 9346,
	"./images/image6.svg": 75581,
	"./images/image7.svg": 17779,
	"./images/image8.svg": 86356,
	"./images/image9.svg": 46490,
	"./images/item1.jpg": 96367,
	"./images/item2.jpg": 98601,
	"./images/item3.jpg": 1789,
	"./images/item4.jpg": 34721,
	"./images/item5.jpg": 46101,
	"./images/item6.jpg": 54089,
	"./images/leadership.jpeg": 48104,
	"./images/leadershipBD1.jpg": 95312,
	"./images/leadershipBD2.jpg": 67017,
	"./images/leadershipBD3.jpg": 56191,
	"./images/leadershipBD4.jpg": 77525,
	"./images/leadershipBD5.jpg": 9241,
	"./images/leadershipSM1.jpg": 36066,
	"./images/leadershipSM2.jpg": 35690,
	"./images/leadershipSM3.jpg": 22091,
	"./images/leadershipSM4.jpg": 56135,
	"./images/leadershipSM5.jpg": 70706,
	"./images/media1.svg": 83764,
	"./images/media2.svg": 73634,
	"./images/media3.svg": 76529,
	"./images/media4.svg": 7238,
	"./images/media5.svg": 73497,
	"./images/partnerProducts1.jpg": 70883,
	"./images/partnerProducts2.jpg": 46321,
	"./images/partnerProducts3.jpg": 71658,
	"./images/partnerProducts4.jpg": 79381,
	"./images/products.jpeg": 5637,
	"./images/rectangle1.png": 6333,
	"./images/rectangle2.png": 71351,
	"./images/rectangle3.png": 32209,
	"./images/rectangle4.png": 52030,
	"./images/rectangle5.png": 34399,
	"./images/school1.jpg": 32497,
	"./images/school2.jpg": 13164,
	"./images/school3.jpg": 79667,
	"./images/school4.jpg": 62430,
	"./images/school4.png": 23656,
	"./images/store.jpeg": 50888,
	"./images/subsidiaries.jpeg": 39464,
	"./images/subsidiariesProducts1.jpg": 42937,
	"./images/subsidiariesProducts2.jpg": 83206,
	"./images/subsidiariesProducts3.jpg": 81779,
	"./images/subsidiariesProducts4.jpg": 54757,
	"./images/subsidiariesProducts5.jpg": 52522,
	"./images/subsidiariesProducts6.jpg": 5200,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./pages/About": 66175,
	"./pages/About.jsx": 66175,
	"./pages/Blog": 41148,
	"./pages/Blog.jsx": 41148,
	"./pages/Career": 76485,
	"./pages/Career.jsx": 76485,
	"./pages/Contact": 91951,
	"./pages/Contact.jsx": 91951,
	"./pages/Gedu": 19626,
	"./pages/Gedu.jsx": 19626,
	"./pages/Home/Hero.css": 34902,
	"./pages/Home/Home": 19544,
	"./pages/Home/Home.jsx": 19544,
	"./pages/Leadership": 11489,
	"./pages/Leadership.jsx": 11489,
	"./pages/NotFound": 69805,
	"./pages/NotFound.jsx": 69805,
	"./pages/Products": 46511,
	"./pages/Products.jsx": 46511,
	"./pages/Shopping/Shopping": 15414,
	"./pages/Shopping/Shopping.css": 22629,
	"./pages/Shopping/Shopping.jsx": 15414,
	"./pages/Subsidiaries": 99947,
	"./pages/Subsidiaries.jsx": 99947,
	"./pdf/private-policy.pdf": 67346,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;